

// import React from 'react';
// import backgroundImage from '../assets/DownloadBG.png';
// import appPreviewImage from '../assets/Rent.png';
// import appleLogo from '../assets/apple.png'; // Replace with your actual file path
// import googlePlayLogo from '../assets/Playstore.png'; // Replace with your actual file path

// function DownloadApp() {
//   return (
//     <>
//     <div
//       className="relative flex flex-col-reverse md:flex-row items-center justify-between w-full h-full rounded-lg md:p-0 sm:p-0 md:pr-10"
//       style={{
//         backgroundImage: `
//           linear-gradient(45deg, rgba(193, 125, 42, 0.8) 0%, rgba(173, 181, 7, 0.9) 100%),
//           url(${backgroundImage})
//         `,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//       }}
//     >
//       <div className="flex flex-col gap-4 text-center md:text-left">
//         <h2 className="text-xl md:text-3xl font-semibold text-black mx-auto md:ml-14">
//           Download MoveonWheels <span className="block">Mobile App on your phone!</span>
//         </h2>

//         <div className="flex flex-row gap-4 justify-center md:justify-start mx-auto md:ml-14">
//           {/* App Store Button */}
//           <a 
//             href="#" 
//             className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg shadow-md w-auto justify-center"
//           >
//             <img 
//               src={appleLogo} 
//               alt="Apple Logo" 
//               className="w-6 h-6"
//             />
//             <div className="flex flex-col text-left">
//               <span className="text-xs">Download on the</span>
//               <span className="text-md font-semibold">App Store</span>
//             </div>
//           </a>

//           {/* Google Play Button */}
//           <a 
//             href="#" 
//             className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg shadow-md w-auto justify-center"
//           >
//             <img 
//               src={googlePlayLogo} 
//               alt="Google Play Logo" 
//               className="w-6 h-6"
//             />
//             <div className="flex flex-col text-left">
//               <span className="text-xs">Get it on</span>
//               <span className="text-md font-semibold">Google Play</span>
//             </div>
//           </a>
//         </div>
//       </div>
      
//       <div className="mt-6 md:mt-0 flex-shrink-0 w-2/3 md:w-1/3 lg:w-1/4">
//         <img src={appPreviewImage} alt="App Preview" className="object-contain w-full" />
//       </div>
//     </div>
//     </>
//   );
// }

// export default DownloadApp;

import React from 'react';
import backgroundImage from '../assets/DownloadBG.png';
import appPreviewImage from '../assets/Rent.png';
import appleLogo from '../assets/apple.png';
import googlePlayLogo from '../assets/Playstore.png';

function DownloadApp() {
  return (
    <div className="m-16"> {/* Added margin here */}
      <div
        className="relative flex flex-col-reverse md:flex-row items-center justify-between w-full h-full rounded-lg md:p-0 sm:p-0 md:pr-10"
        style={{
          backgroundImage: `
            linear-gradient(45deg, rgba(193, 125, 42, 0.8) 0%, rgba(173, 181, 7, 0.9) 100%),
            url(${backgroundImage})
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="flex flex-col gap-4 text-center md:text-left">
          <h2 className="text-xl md:text-3xl font-semibold text-black mx-auto md:ml-14">
            Download MoveonWheels <span className="block">Mobile App on your phone!</span>
          </h2>

          <div className="flex flex-row gap-4 justify-center md:justify-start mx-auto md:ml-14">
            {/* App Store Button */}
            <a 
              href="#" 
              className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg shadow-md w-auto justify-center"
            >
              <img 
                src={appleLogo} 
                alt="Apple Logo" 
                className="w-6 h-6"
              />
              <div className="flex flex-col text-left">
                <span className="text-xs">Download on the</span>
                <span className="text-md font-semibold">App Store</span>
              </div>
            </a>

            {/* Google Play Button */}
            <a 
              href="#" 
              className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg shadow-md w-auto justify-center"
            >
              <img 
                src={googlePlayLogo} 
                alt="Google Play Logo" 
                className="w-6 h-6"
              />
              <div className="flex flex-col text-left">
                <span className="text-xs">Get it on</span>
                <span className="text-md font-semibold">Google Play</span>
              </div>
            </a>
          </div>
        </div>
        
        <div className="mt-6 md:mt-0 flex-shrink-0 w-2/3 md:w-1/3 lg:w-1/4">
          <img src={appPreviewImage} alt="App Preview" className="object-contain w-full" />
        </div>
      </div>
    </div>
  );
}

export default DownloadApp;
